import { LearnerPageChrome } from "@/pages/learners/page-chrome"
import { PageBody } from "@/components/ui/layout"
import { FormRenderer } from "@/lib/data-driven-forms/renderer"
import { useId } from "react"
import { SaveButton } from "@/components/shared/action-buttons"

import { useFormProps } from "../students/page-props"
import { formSchema } from "../students/form-schema"
import { useNavigate } from "@/lib/page-rendering"

export default function Page() {
  const navigate = useNavigate()
  const id = useId()

  const { student, student_attachments } = useFormProps()

  const handleSubmit = (data: any) => {
    navigate({
      href: ".",
      method: "post",
      data: {
        student_json: JSON.stringify(data.student),
        student_attachments: data.student_attachments,
      },
      formData: true,
    })
  }

  return (
    <>
      <LearnerPageChrome action={<SaveButton form={id} />} />
      <PageBody>
        <FormRenderer
          schema={formSchema}
          formId={id}
          onSubmit={handleSubmit}
          defaultValues={{ student, student_attachments }}
        />
      </PageBody>
    </>
  )
}
